var store = {
  debug: true,
  state: {
    welfare: null,
    users: []
  },
  setWelfare (newValue) {
    this.state.welfare = newValue
  },
  setUsers (newUsers) {
    this.state.users = newUsers
  },
  clearMessageAction () {
    this.state.message = ''
  }
}
// eslint-disable-next-line semi
export default store;
